import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

// Define the CanComponentDeactivate interface
export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const ValidationGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate,
) => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
